module.exports = __webpack_public_path__ + "static/img/2.bff57a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v16_new_features/2.png
// module id = mttd
// module chunks = 0